import classNames from 'classnames';
import React, { ReactEventHandler, ElementType, PropsWithChildren, forwardRef } from 'react';

import { IconView } from '../../IconView/IconView';
import { IMenuItemProps, MenuItem } from '../../MenuItem/MenuItem';
import { IPopoverMenuItem } from '../PopoverMenu.types';

export interface IPopoverMenuItemProps
  extends Pick<
    IMenuItemProps,
    'theme' | 'onMouseEnter' | 'onMouseLeave' | 'isSelected' | 'iconSuffix' | 'suffix' | 'size'
  > {
  item: IPopoverMenuItem;
  onClose?(): void;
  onClick?(): void;
  className?: string;
  icon?: ElementType;
}

export const PopoverMenuItem = forwardRef<HTMLElement, PropsWithChildren<IPopoverMenuItemProps>>(
  (props, ref) => {
    const {
      item,
      className,
      theme,
      onClose,
      icon,
      children,
      onClick,
      onMouseEnter,
      onMouseLeave,
      isSelected,
      iconSuffix,
      suffix,
      size,
    } = props;

    const handleClick: ReactEventHandler<HTMLButtonElement> = (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (item.closeByClick ?? true) {
        onClose?.();
      }

      item.onClick?.(e);
      onClick?.();
    };

    const itemIcon = icon || item.icon;

    return (
      <MenuItem
        className={classNames(item.className, className)}
        titleClassName={item.titleClassName}
        key={item.key}
        title={item.title || ''}
        onClick={handleClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        icon={
          item.customIcon ||
          (itemIcon && (
            <IconView
              Icon={itemIcon}
              className={item.iconClassName}
            />
          ))
        }
        iconSuffix={item.iconSuffix || iconSuffix}
        suffix={item.suffix || suffix}
        dataTest={`menu-item-${item.key}`}
        theme={theme}
        style={item.style}
        isDisabled={item.isDisabled}
        count={item.count}
        ref={ref}
        isSelected={isSelected}
        size={size}
      >
        {children}
      </MenuItem>
    );
  }
);
